import { http } from '@/api';
import { SELF_EMPLOYMENT_INITIAL } from '@/app/business/store/state';
import { REFRESH_REQUEST } from '@/app/auth/store/types';
import lodash from 'lodash';
import {
  SET_PARAM,
  COMPLIANCE,
  CHECK_COMPLIANCE,
  SET_COMPLIANCE,
  SET_SELF_EMPLOYMENT,
  FETCH_SELF_EMPLOYMENT,
  FETCH_ACCOUNTS_RECEIVABLE,
  DELETE_ACCOUNT_RECEIVABLE,
  FETCH_ACCOUNT_RECEIVABLE_DETAILS,
  ADD_ACCOUNT_RECEIVABLE,
  FETCH_MERCHANT_ACCOUNT,
  ADD_MERCHANT_ACCOUNT,
  SET_ACCOUNTS_RECEIVABLE,
  SET_MERCHANT_ACCOUNTS,
  UPDATE_ACCOUNT_RECEIVABLE,
  DELETE_MERCHANT_ACCOUNT,
  FETCH_MERCHANT_ACCOUNT_DETAILS,
  UPDATE_MERCHANT_ACCOUNT,
  MARK_AS_COMPLETE,
  RESET_SELF_EMPLOYMENT,
  FETCH_PROFILE_DATA,
  SET_INITIAL_COMPLIANCE,
  SET_INITIAL_BUSINESS_INFO,
} from './constants';


export default {
  [CHECK_COMPLIANCE]: ({ rootGetters, commit, dispatch }) => new Promise((resolve, reject) => {
    const userId = rootGetters.getUserId;

    http.get(`/business/apps/${userId}/compliance`)
      .then((resp) => {
        const { isCarryForServicesOrProducts: value } = resp.data;
        commit(SET_PARAM, { type: COMPLIANCE, value });
        commit(SET_INITIAL_COMPLIANCE, value);
        resolve(resp);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(REFRESH_REQUEST, null, { root: true }).then(() => {
            dispatch(CHECK_COMPLIANCE);
          });
        } else {
          reject(err);
        }
      });
  }),
  [SET_COMPLIANCE]: ({ rootGetters, state }) => new Promise((resolve, reject) => {
    const userId = rootGetters.getUserId;
    const data = {
      isCarryForServicesOrProducts: state[COMPLIANCE],
    };
    const { initialCompliance } = state;
    if (initialCompliance === data.isCarryForServicesOrProducts) {
      resolve();
      return;
    }

    http.put(`/business/apps/${userId}/compliance`, data)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(err);
      });
  }),
  [SET_SELF_EMPLOYMENT]: ({ rootGetters, state }) => new Promise((resolve, reject) => {
    const userId = rootGetters.getUserId;
    const payload = {
      ...state.selfEmployment,
      hasBusinessEIN: !state.selfEmployment.noEIN,
    };
    if (lodash.isEqual(state.initialBusinessInfo, payload)) {
      resolve();
      return;
    }

    http.put(`/business/apps/${userId}/business-information`, payload)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(err);
      });
  }),
  [RESET_SELF_EMPLOYMENT]: ({ commit }) => {
    commit(SET_SELF_EMPLOYMENT, SELF_EMPLOYMENT_INITIAL);
  },
  [FETCH_SELF_EMPLOYMENT]: ({ rootGetters, commit, dispatch }) => new Promise((resolve, reject) => {
    const userId = rootGetters.getUserId;

    http.get(`/business/apps/${userId}/business-information`)
      .then((resp) => {
        commit(SET_SELF_EMPLOYMENT, {
          ...resp.data,
          noEIN: !resp.data.hasBusinessEIN,
        });
        commit(SET_INITIAL_BUSINESS_INFO, {
          ...resp.data,
          noEIN: !resp.data.hasBusinessEIN,
        });
        resolve(resp);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(REFRESH_REQUEST, null, { root: true }).then(() => {
            dispatch(FETCH_SELF_EMPLOYMENT);
          });
        } else {
          reject(err);
        }
      });
  }),
  [FETCH_ACCOUNTS_RECEIVABLE]: (
    { rootGetters, commit, dispatch },
  ) => new Promise((resolve, reject) => {
    const userId = rootGetters.getUserId;

    http.get(`/business/apps/${userId}/account-receivable`)
      .then((resp) => {
        const mappedItems = resp.data.map(item => ({
          id: item.id,
          name: item.businessName,
          amount: item.amountOwed,
          address: item.addressLine1,
        }));

        commit(SET_ACCOUNTS_RECEIVABLE, mappedItems);
        resolve(resp);
      })
      .catch((err) => {
        if (err.response.status === 404) {
          commit(SET_ACCOUNTS_RECEIVABLE, []);
          resolve(err);
        } else if (err.response.status === 401) {
          dispatch(REFRESH_REQUEST, null, { root: true }).then(() => {
            dispatch(FETCH_ACCOUNTS_RECEIVABLE);
          });
        } else {
          reject(err);
        }
      });
  }),
  [ADD_ACCOUNT_RECEIVABLE]: ({ rootGetters, dispatch }, data) => new Promise((resolve, reject) => {
    const userId = rootGetters.getUserId;

    http.post(`/business/apps/${userId}/account-receivable`, data)
      .then((resp) => {
        dispatch(FETCH_ACCOUNTS_RECEIVABLE).then(() => {
          resolve(resp);
        });
      })
      .catch((err) => {
        reject(err);
      });
  }),
  [UPDATE_ACCOUNT_RECEIVABLE]: ({
    rootGetters,
    dispatch,
  }, { id, data }) => new Promise((resolve, reject) => {
    const userId = rootGetters.getUserId;

    http.put(`/business/apps/${userId}/account-receivable/${id}`, data)
      .then((resp) => {
        dispatch(FETCH_ACCOUNTS_RECEIVABLE).then(() => {
          resolve(resp);
        });
      })
      .catch((err) => {
        reject(err);
      });
  }),
  [DELETE_ACCOUNT_RECEIVABLE]: ({ rootGetters, dispatch }, id) => new Promise((resolve, reject) => {
    const userId = rootGetters.getUserId;

    http.delete(`/business/apps/${userId}/account-receivable/${id}`)
      .then((resp) => {
        dispatch(FETCH_ACCOUNTS_RECEIVABLE).then(() => {
          resolve(resp);
        });
      })
      .catch((err) => {
        reject(err);
      });
  }),
  [FETCH_ACCOUNT_RECEIVABLE_DETAILS]: ({ rootGetters, dispatch },
    id) => new Promise((resolve, reject) => {
    const userId = rootGetters.getUserId;

    http.get(`/business/apps/${userId}/account-receivable/${id}`)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(REFRESH_REQUEST, null, { root: true }).then(() => {
            dispatch(FETCH_ACCOUNT_RECEIVABLE_DETAILS);
          });
        } else {
          reject(err);
        }
      });
  }),
  [FETCH_MERCHANT_ACCOUNT]: (
    { rootGetters, commit, dispatch },
  ) => new Promise((resolve, reject) => {
    const userId = rootGetters.getUserId;

    http.get(`/business/apps/${userId}/merchant-account`)
      .then((resp) => {
        const mappedItems = resp.data.map(item => ({
          id: item.id,
          accountNumber: item.accountNumber,
          bankName: item.issuingBankName,
          address: item.issuingBankAddressLine1,
          cardType: item.creditCardType,
        }));

        commit(SET_MERCHANT_ACCOUNTS, mappedItems);
        resolve(resp);
      })
      .catch((err) => {
        if (err.response.status === 404) {
          commit(SET_MERCHANT_ACCOUNTS, []);
          resolve(err);
        } else if (err.response.status === 401) {
          dispatch(REFRESH_REQUEST, null, { root: true }).then(() => {
            dispatch(FETCH_MERCHANT_ACCOUNT);
          });
        } else {
          reject(err);
        }
      });
  }),
  [ADD_MERCHANT_ACCOUNT]: ({ rootGetters, dispatch }, data) => new Promise((resolve, reject) => {
    const userId = rootGetters.getUserId;

    http.post(`/business/apps/${userId}/merchant-account`, data)
      .then((resp) => {
        dispatch(FETCH_MERCHANT_ACCOUNT).then(() => {
          resolve(resp);
        });
      })
      .catch((err) => {
        reject(err);
      });
  }),
  [DELETE_MERCHANT_ACCOUNT]: ({ rootGetters, dispatch }, id) => new Promise((resolve, reject) => {
    const userId = rootGetters.getUserId;

    http.delete(`/business/apps/${userId}/merchant-account/${id}`)
      .then((resp) => {
        dispatch(FETCH_MERCHANT_ACCOUNT).then(() => {
          resolve(resp);
        });
      })
      .catch((err) => {
        reject(err);
      });
  }),
  [FETCH_MERCHANT_ACCOUNT_DETAILS]: ({ rootGetters, dispatch },
    id) => new Promise((resolve, reject) => {
    const userId = rootGetters.getUserId;

    http.get(`/business/apps/${userId}/merchant-account/${id}`)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(REFRESH_REQUEST, null, { root: true }).then(() => {
            dispatch(FETCH_MERCHANT_ACCOUNT_DETAILS);
          });
        } else {
          reject(err);
        }
      });
  }),
  [UPDATE_MERCHANT_ACCOUNT]: ({
    rootGetters,
    dispatch,
  }, { id, data }) => new Promise((resolve, reject) => {
    const userId = rootGetters.getUserId;

    http.put(`/business/apps/${userId}/merchant-account/${id}`, data)
      .then((resp) => {
        dispatch(FETCH_MERCHANT_ACCOUNT).then(() => {
          resolve(resp);
        });
      })
      .catch((err) => {
        reject(err);
      });
  }),
  [MARK_AS_COMPLETE]: ({ rootGetters }) => new Promise((resolve, reject) => {
    const userId = rootGetters.getUserId;

    http.put(`/business/apps/${userId}/complete-section`)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        reject(err);
      });
  }),
  [FETCH_PROFILE_DATA]: ({ rootGetters }) => new Promise(((resolve, reject) => {
    const userId = rootGetters.getUserId;

    http.get(`/personal/apps/${userId}/profile`)
      .then((resp) => {
        resolve(resp);
      })
      .catch((err) => {
        if (err.response.status !== 404) {
          reject(err);
        }
      });
  })),
};
